import StartupUsers from './container';

export default StartupUsers;
